import React from 'react';
export const Space = () => <>&nbsp;</>;
